import { Injectable } from '@angular/core';
import { Receiver } from '../model/receiver';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { ReceiverType } from '../model/receiver-type';
import { ChatMessage } from '../model/chat-message';
import { UnreadChannelMessage } from '../model/unread-channel-message';
import { StoreService } from 'src/app/store/service/store.service';
import { StoreContent } from 'src/app/store/model/store-model';
import { map, takeUntil, tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ChannelService {

  readonly unreadStoreName = 'unreadChannelMessage';
  private actualSubscribedChannel: string = '';
  unreadMessageCount: UnreadChannelMessage[];

  private receiversSubject: Subject<Receiver[]> = new BehaviorSubject([]);
  receiversObservable$: Observable<Receiver[]> = this.receiversSubject.asObservable();
  private unsubscribe$: Subject<void> = new Subject();

  constructor( private storeService: StoreService) {}

  pushReceivers(receivers: Receiver[]): void {
    this.receiversSubject.next(receivers);
  }

  pushDefaultReceivers(): void {
    this.receiversSubject.next([Object.assign(new Receiver(), {
      name: ReceiverType.ALL,
      receiverType: ReceiverType.ALL
    })]);
  }

  getDataObservable(): Observable<ChatMessage[]> {
    if (!this.storeService.isStorageTypeExists(ChatMessage.getName())) {
      this.storeService.addStorageType(ChatMessage.getName(), new StoreContent<ChatMessage>((data: ChatMessage) => data.id));
    }
    return this.storeService.connectToAllDataUpdates<ChatMessage>(ChatMessage.getName())
      .pipe(
        map(data =>
          data.filter(message =>
            message.channel === this.actualSubscribedChannel || message.receivers?.map(rcv => rcv.name).includes(this.actualSubscribedChannel)))
            );
  }

  getUnreadObservable(): Observable<UnreadChannelMessage[]> {
    if (!this.storeService.isStorageTypeExists(this.unreadStoreName)) {
      this.storeService
        .addStorageType(this.unreadStoreName, new StoreContent<UnreadChannelMessage>((data: UnreadChannelMessage) => data.channel));
    }
    return this.storeService
      .connectToAllDataUpdates<UnreadChannelMessage>(this.unreadStoreName).pipe(takeUntil(this.unsubscribe$), tap(data => this.unreadMessageCount = data));
  }

  setActualChannel(channel: string): void {
    this.actualSubscribedChannel = channel;
  }

  unstoreData(): void {
    if (this.storeService.isStorageTypeExists(ChatMessage.getName()))
      this.storeService.clear(ChatMessage.getName());
    this.actualSubscribedChannel = '';
  }

  unsubscribeData(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  getUnreadForChannel(channel: string): number {
    const unread: number = this.unreadMessageCount?.find(unrCount => unrCount.channel === channel)?.unread;
    return unread ? unread : undefined;
  }
}

